import RequestManager from "src/requests/RequestManager";
import { Match } from "../interfaces";
import { isMockDataActive } from "../mockData";
import { MatchTask } from "../tasks";
import { parseMatch } from "../utils";
import { match as resultMock } from "../mockData";

enum MatchStatus {
    COMPLETED = "COMPLETED",
    SCHEDULED = "SCHEDULED",
    IN_PROGRESS = "IN_PROGRESS"
}

enum MatchPeriods {
    FIRST = "1",
    SECONDE = "2",
    END = "E"
}

// Se usa en VCardPartido
export default async function getMatchById(matchId: string): Promise<Match> {
   
    const task = new MatchTask(matchId);
    let result;
    if(isMockDataActive) {
        result = resultMock;
    } else {
        result = await RequestManager.addRequest(task);
    }
    const match = result.match || {};
    return parseMatch(match);
}


// WEBPACK FOOTER //
// ./src/mundial/requests/api/getMatchById.ts